import { useQuery } from 'react-query';
import { useDispatch } from 'react-redux';

import { makeResourceKeys } from 'requests/resources/makeResources/makeResourcesKeys';

import axiosClient from '@lib/utils/axiosClient';

import { snackbarError } from 'actions/snackbarMessage';

import { TCustomWebStylesModelV2 } from '../types';

const BASE_URL = 'customWebStyles';

interface ReturnData {
  response: TCustomWebStylesModelV2[];
}

export const key = makeResourceKeys('custom-web-styles');

const queryFn = () =>
  axiosClient
    .get<ReturnData>(`v2/${BASE_URL}?limit=3&_sort=createdAt:desc`)
    .then(({ data }) => data?.response?.reverse());

// Hooks
type UseGetCustomWebStylesParams = { enabled?: boolean };
export const useGetCustomWebStyles = (options?: UseGetCustomWebStylesParams) => {
  const dispatch = useDispatch();
  const enabled = options?.enabled ?? true;
  return useQuery(key.$all, queryFn, {
    refetchOnWindowFocus: false,
    retry: 2,
    onError: () => dispatch(snackbarError('Something went wrong')),
    enabled,
  });
};
